import React, { useContext } from "react";
import styled from "styled-components";
import Wrapper from "../layout/Wrapper";
import Switch from "./switch";
import { ProductContext } from "./product-context";
import Panel from "./panel";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./animaciones-producto.css";

const s = 6;

const Container = styled(Wrapper)`
  padding-bottom: ${props => props.theme.space[s]}px;
  box-sizing: border-box;
  position: relative;

  @media only screen and (min-width: ${props => props.theme.breakpoints[1]}px) {
    padding-top: ${props => props.theme.space[s]}px;
    display: flex;
    justify-content: space-between;
  }
`;

const SwitchContainer = styled.div`
  display: grid;
  grid-template-columns: 4fr 3fr;
  grid-template-areas: "titulo switcher";
  grid-gap: ${props => props.theme.space[2]}px;
  border-bottom: 1px solid ${p => p.theme.colors.grisClaro};
  margin-bottom: ${props => props.theme.space[3]}px;
  margin-right: -20px;
  padding-top: ${props => props.theme.space[3]}px;
  padding-bottom: ${props => props.theme.space[3]}px;
  padding-right: ${props => props.theme.space[1]}px;
  font-size: 0.8em;
  box-sizing: border-box;
  max-height: 100px;
  overflow: visible;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 2;

  @media only screen and (min-width: ${props => props.theme.breakpoints[1]}px) {
    display: block;
    height: 300px;
    width: 300px;
    top: ${props => props.theme.space[s]}px;
    flex: none;
    margin-right: ${props => props.theme.space[s]}px;
    border-bottom: none;
    font-size: 0.9em;
    max-height: none;
    padding-top: 0;
    padding-bottom: 0;

    .switch-titulo {
      margin-bottom: ${props => props.theme.space[2]}px;
    }
  }

  .switch-switcher {
    box-sizing: border-box;
    background: #fff;
    z-index: 1;
  }

  h2 {
    margin: 0;
    line-hight: 1em;
  }
  p {
    margin: 0;
  }
`;

const MainContent = styled.div`
  position: relative;
  transition: all 0.5s ease;
  z-index: 0;
`;

export default ({ children, variaciones, titulo, descripcion }) => {
  const { selectedColorKey } = useContext(ProductContext);
  const producto = variaciones[selectedColorKey];
  return (
    <Container>
      <SwitchContainer>
        <div className="switch-titulo">
          <h2>
            {titulo}
          </h2>
          <p>{descripcion}</p>
        </div>
        <div className="switch-switcher">
          <Switch id="" {...{ variaciones }} />
        </div>
      </SwitchContainer>
      <MainContent>
        <TransitionGroup>
          <CSSTransition key={producto.id} timeout={150} classNames="panel">
            <Panel>{children}</Panel>
          </CSSTransition>
        </TransitionGroup>
      </MainContent>
    </Container>
  );
};
